const toIsoDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export const getLastCompleteMonthPeriod = (today = new Date()) => {
    const end = new Date(today.getFullYear(), today.getMonth(), 0);
    const start = new Date(end.getFullYear(), end.getMonth() - 11, 1);

    return {
        startDate: toIsoDate(start),
        endDate: toIsoDate(end),
        monthName: end.toLocaleString("en-US", {month: "short"}),
    };
};

export const getPreviousMonthValue = (currentValue, momPercentage) => {
    const current = Number(String(currentValue ?? "").replace(/[^0-9.-]/g, ""));
    const percentage = Number(String(momPercentage ?? "").replace(/[^0-9.-]/g, ""));

    if (!Number.isFinite(current)) return "--";
    if (!Number.isFinite(percentage) || percentage <= -100) return Math.round(current);

    return Math.round(current / (1 + percentage / 100));
};
